import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import scaleByWindow from "../../decorators/scaleByWindow";
import contextMenuTrigger from "../../decorators/contextMenuTrigger";
import {CANVAS} from "../../constants";

class Canvas extends PureComponent {
  static propTypes = {
    background: PropTypes.string
  };
  render() {
    const {background} = this.props;
    return (
      <React.Fragment>
        <img loading="lazy"
          src={background}
          style={{
            position: `absolute`,
            top: `0`,
            left: `50%`,
            transform: `translate(-50%)`
          }}
        />
        <canvas id={CANVAS.ID} width={CANVAS.WIDTH} height={CANVAS.HEIGHT} />
      </React.Fragment>
    );
  }
}

export default contextMenuTrigger(
  scaleByWindow({width: CANVAS.WIDTH, height: CANVAS.HEIGHT})(Canvas)
);
